<template>
  <b-navbar variant="faded" type="light" id="navbar">
    <b-navbar-brand href="#" class="ml-auto mr-auto">
      <img src="/static/maisoncannoise_logorectangle2.png" width="300px" alt="Kitten">
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavBar'
}
</script>

<style scoped>
#navbar{
  -webkit-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.50);
  -moz-box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.50);
  box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.50);
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue